<template>
    <main class="main a-permissionDenied">
        <div class="a-permissionDenied__descWrapper">
            <h2 class="h2 a-permissionDenied__title text-center">403</h2>
            <h4
                class="h5 a-permissionDenied__desc text-center"
                v-html="permissionDeniedText"
            ></h4>
        </div>
        <div>
            <button class="btn btn-secondary" @click="onButtonClick">
                Przejdź do pulpitu
            </button>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PermissionDenied',
    methods: {
        onButtonClick() {
            this.$router.push({ name: 'dashboard' })
        }
    },
    computed: {
        permissionDeniedText() {
            return !this.$store.getters.isShopUser
                ? 'Nie posiadasz uprawnień do przeglądania tej strony'
                : 'Jesteś zalogowany jako Użytkownik Sklepowy.<br/>Nie posiadasz uprawnień do przeglądania tej strony'
        }
    }
}
</script>
